import { LayoutProps } from '@app/types'

import { StyledContent } from './elements'

export const Content: React.FC<LayoutProps> = (props) => <StyledContent {...props} />
